import LoginPage from './login.page.vue'

let loginRoutes = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  }
]

export default loginRoutes
